import * as THREE from 'three';
import { LODStaticObject, StaticObjectType } from './LODStaticObject';

/**
 * Optimized Bush with Level of Detail support
 * Uses the improved LODStaticObject base class for efficient LOD transitions
 * Composed of several low-poly spherical objects with flat shading to show triangles
 */
export class LODBush extends LODStaticObject {
  constructor() {
    // Create custom materials with flat shading to show the triangles
    // and properly set up for shadows
    const highLODMaterial = new THREE.MeshStandardMaterial({
      color: 0x2E8B57, // Sea green
      roughness: 0.8,
      metalness: 0.1,
      flatShading: true, // Enable flat shading to see triangles
      shadowSide: THREE.FrontSide, // Properly cast shadows
      dithering: true // Improve shadow edge quality
    });
    
    const mediumLODMaterial = new THREE.MeshStandardMaterial({
      color: 0x3CB371, // Medium sea green
      roughness: 0.8,
      metalness: 0.1,
      flatShading: true, // Enable flat shading to see triangles
      shadowSide: THREE.FrontSide, // Properly cast shadows
      dithering: true // Improve shadow edge quality
    });
    
    const lowLODMaterial = new THREE.MeshStandardMaterial({
      color: 0x32CD32, // Lime green
      roughness: 0.7,
      metalness: 0.0,
      flatShading: true, // Enable flat shading to see triangles
      shadowSide: THREE.FrontSide, // Properly cast shadows
      dithering: true // Improve shadow edge quality
    });
    
    // Create with bush-specific configuration
    super({
      type: StaticObjectType.BUSH,
      name: 'LODBush',
      baseScale: new THREE.Vector3(1.2, 0.8, 1.2), // 0.8 meters tall and 1.2 meters wide
      materialOverrides: {
        // Use custom materials with flat shading for all LOD levels
        high: highLODMaterial,
        medium: mediumLODMaterial,
        low: lowLODMaterial
      }
    });
  }
} 